<div class="container">
  <div class="row">
    <div class="col-xs-12">
      <img class="logo"
           src="https://cdn.storagepug.com/hubfs/logo/logo_purple_pug.png"
           alt="">
    </div>
  </div>

  <div class="row">
    <div class="col-xs-12">
      <div class="wrapper">
        <div *ngIf="error"
             class="error"
             role="alert">
          <span class="glyphicon glyphicon-exclamation-sign"
                aria-hidden="true"></span>
          <span class="sr-only">Error:</span>
          {{error }}
        </div>
        <form class="form-signin"
              (ngSubmit)="loginUser($event)">
          <h2 class="form-signin-heading text-center">Login</h2>
          <md-input-container class="full-width">
            <input mdInput
                   [(ngModel)]="email"
                   type="email"
                   name="username"
                   placeholder="Email Address"
                   required>
          </md-input-container>
          <md-input-container class="full-width">
            <input mdInput
                   [(ngModel)]="password"
                   type="password"
                   name="password"
                   placeholder="Password"
                   required>
          </md-input-container>
          <button class="btn btn-secondary"
                  color="accent"
                  class="btn btn-lg btn-default full-width"
                  type="submit">Login</button>
        </form>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/ng2/app/admin-portal/login/login.component.html